/**
 * Detects if the device is mobile based on screen width and user agent
 * @returns {boolean} true if mobile device
 */
export const isMobileDevice = () => {
  // Check screen width (most reliable)
  if (window.innerWidth <= 768) {
    return true;
  }
  
  // Check user agent as fallback
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
};

/**
 * Handles report navigation - opens in new tab on mobile, same tab on desktop
 * @param {Function} navigate - React Router navigate function
 * @param {string} path - Path to navigate to (e.g., '/reports/R0007496')
 */
export const handleReportNavigation = (navigate, path) => {
  if (isMobileDevice()) {
    // Open in new tab on mobile
    const baseUrl = window.location.origin;
    window.open(`${baseUrl}${path}`, '_blank');
  } else {
    // Navigate in same tab on desktop
    navigate(path);
  }
};
